


export function getCurrentContext()
{
    $('.blog-row .blog-txt .link-text').click(function (e:any)
    {
        localStorage.setItem('current_context_url', window.location.href);
    });
}
